// Light Mode Color Foundation

export default {
   // Global
   globalNavLogoFieldName: 'logoDefault',
   tmpBackgroundColor: '#f5f5f5',
   tmpBodyTextColor: '#666',
   tmpFooterBackgroundColor: '#eee',
   // Aside
   tmpAsideBodyTextColor: '#777',
   tmpAsideButtonActiveBackgroundColor: '#ddd',
   tmpAsideButtonActiveTextColor: '#111',
   tmpAsideButtonTextColor: '#666',
   tmpAsideLineColor: '#e5e5e5',
   tmpAsideTitleColor: '#222',
   // Content
   tmpContentBackgroundColor: '#fff',
   tmpContentLineColor: '#efefef',
   tmpContentTitleColor: '#333',
   // Main Menu
   tmpMainMenuBackgroundColor: '#fff',
   tmpMainMenuBorderColor: '#f5f5f5',
   tmpMainMenuButtonTextColor: '#777',
   tmpMainMenuButtonActiveTextColor: '#111',
   tmpMainMenuButtonActiveBackgroundColor: '#eee',
   tmpMainMenuLineColor: '#efefef',
   tmpMainMenuSearchBackgroundColor: '#eee',
   tmpMainMenuTextColor: '#777',
   tmpMainMenuTitleColor: '#333',
   // Will change
   tmpBorderColor: '#e5e5e5',
   tmpColumnBorderColor: '#f5f5f5'
}
